import {faCircleInfo} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Popover} from 'antd';

import {Text} from '../../../../../../component/text/text';
import {Locale} from '../../../../../../provider/locale/localization';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {SourceLinkStatusEnum} from '../../../../../../service/source-settings/source-links/source-links-type';
import {classNames} from '../../../../../../util/css';
import {NeverError} from '../../../../../../util/error';

import * as styles from './status-cell.scss';

type PropsType = {
    status: SourceLinkStatusEnum;
    errorText?: string | null;
    /** When status is Fail, overrides the default "Fail" label (e.g. App Store account status). */
    failStatusLabelStringKey?: LangKeyType | null;
};

// eslint-disable-next-line complexity
export function StatusCell(props: PropsType): JSX.Element {
    const {status, errorText = null, failStatusLabelStringKey} = props;

    switch (status) {
        case SourceLinkStatusEnum.Synchronization:
            return (
                <Popover
                    content={errorText ?? ''}
                    title={errorText ? <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__ERROR_TEXT__TITLE" /> : ''}
                >
                    <div className={styles.StatusCell} role="status">
                        <Text
                            className={styles.StatusCell_label}
                            stringKey="SOURCE_SETTINGS__LINKS__LINKS__STATUS__SYNCHRONIZATION"
                        />
                        {errorText ? <FontAwesomeIcon className={styles.StatusCell_icon} icon={faCircleInfo} /> : null}
                    </div>
                </Popover>
            );
        case SourceLinkStatusEnum.Synced:
            return (
                <Popover
                    content={errorText ?? ''}
                    title={errorText ? <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__ERROR_TEXT__TITLE" /> : ''}
                >
                    <div className={classNames(styles.StatusCell, styles.StatusCell__synced)} role="status">
                        <Text
                            className={styles.StatusCell_label}
                            stringKey="SOURCE_SETTINGS__LINKS__LINKS__STATUS__SYNCED"
                        />
                        {errorText ? <FontAwesomeIcon className={styles.StatusCell_icon} icon={faCircleInfo} /> : null}
                    </div>
                </Popover>
            );
        case SourceLinkStatusEnum.Fail:
            return (
                <Popover
                    content={errorText ?? ''}
                    title={errorText ? <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__ERROR_TEXT__TITLE" /> : ''}
                >
                    <div className={classNames(styles.StatusCell, styles.StatusCell__error)} role="status">
                        {failStatusLabelStringKey ? (
                            <Text className={styles.StatusCell_label} stringKey={failStatusLabelStringKey} />
                        ) : (
                            <Text
                                className={styles.StatusCell_label}
                                stringKey="SOURCE_SETTINGS__LINKS__LINKS__STATUS__FAIL"
                            />
                        )}
                        {errorText ? <FontAwesomeIcon className={styles.StatusCell_icon} icon={faCircleInfo} /> : null}
                    </div>
                </Popover>
            );
        default:
            throw new NeverError(status);
    }
}
